import { useEffect, useState } from 'react'
import { motion } from 'framer-motion'

interface Props {
  onDone: () => void
}

export default function Preloader({ onDone }: Props) {
  const [typed, setTyped] = useState('')
  const [done, setDone] = useState(false)
  const fullText = 'matheus edson'

  useEffect(() => {
    let i = 0
    const delay = setTimeout(() => {
      const interval = setInterval(() => {
        i++
        setTyped(fullText.slice(0, i))
        if (i >= fullText.length) {
          clearInterval(interval)
          setTimeout(() => {
            setDone(true)
            setTimeout(onDone, 600)
          }, 700)
        }
      }, 80)
      return () => clearInterval(interval)
    }, 300)
    return () => clearTimeout(delay)
  }, [onDone])

  return (
    <motion.div
      exit={{ opacity: 0, scale: 1.04 }}
      transition={{ duration: 0.5, ease: 'easeInOut' }}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'var(--bg)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '2rem',
        zIndex: 100,
      }}
    >
      {/* Pulsing avatar circle */}
      <motion.div
        animate={done ? { scale: 0.4, y: -80, opacity: 0 } : { scale: [1, 1.05, 1] }}
        transition={done
          ? { duration: 0.5, ease: 'easeInOut' }
          : { duration: 2, repeat: Infinity, ease: 'easeInOut' }
        }
        style={{
          position: 'relative',
          width: 140,
          height: 140,
        }}
      >
        {/* Pulse rings */}
        {[1, 2, 3].map(i => (
          <motion.div
            key={i}
            animate={{ scale: [1, 1.6], opacity: [0.3, 0] }}
            transition={{ duration: 2, repeat: Infinity, delay: i * 0.4, ease: 'easeOut' }}
            style={{
              position: 'absolute',
              inset: 0,
              borderRadius: '50%',
              border: '1px solid rgba(79,126,247,0.4)',
            }}
          />
        ))}

        {/* Avatar circle */}
        <div style={{
          width: 140,
          height: 140,
          borderRadius: '50%',
          background: 'var(--bg3)',
          border: '2px solid var(--accent)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
          position: 'relative',
        }}>
          <img src="/matheus.webp" alt="Matheus Edson" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
        </div>
      </motion.div>

      {/* Typing text */}
      <motion.div
        animate={done ? { opacity: 0, y: -10 } : { opacity: 1 }}
        transition={{ duration: 0.3 }}
        style={{
          fontSize: '1.5rem',
          fontWeight: 500,
          letterSpacing: '-0.02em',
          color: 'var(--text)',
          minHeight: '2rem',
          display: 'flex',
          alignItems: 'center',
          gap: 2,
        }}
      >
        {typed}
        <motion.span
          animate={{ opacity: [1, 0] }}
          transition={{ duration: 0.5, repeat: Infinity, ease: 'linear' }}
          style={{ display: 'inline-block', width: 2, height: '1.2em', background: 'var(--accent)', borderRadius: 1 }}
        />
      </motion.div>
    </motion.div>
  )
}
